/**
 * Curated list of timezones offered in the onboarding/settings pickers.
 *
 * Heavy on US zones since the user base is US-first; a handful of common
 * international zones cover the rest. Free-form IANA strings are still
 * accepted by the server, so power users can paste any zone they want into
 * the input field.
 */

export type TimezoneOption = { value: string; label: string };

export const TIMEZONES: TimezoneOption[] = [
  { value: "America/Los_Angeles", label: "Pacific Time, Los Angeles (PT)" },
  { value: "America/Denver", label: "Mountain Time, Denver (MT)" },
  { value: "America/Phoenix", label: "Arizona, Phoenix (no DST)" },
  { value: "America/Chicago", label: "Central Time, Chicago (CT)" },
  { value: "America/New_York", label: "Eastern Time, New York (ET)" },
  { value: "America/Anchorage", label: "Alaska, Anchorage (AKT)" },
  { value: "Pacific/Honolulu", label: "Hawaii, Honolulu (HST)" },
  { value: "America/Toronto", label: "Eastern Canada, Toronto" },
  { value: "America/Vancouver", label: "Pacific Canada, Vancouver" },
  { value: "America/Mexico_City", label: "Mexico City" },
  { value: "Europe/London", label: "United Kingdom, London" },
  { value: "Europe/Paris", label: "Central Europe, Paris" },
  { value: "Asia/Tokyo", label: "Japan, Tokyo" },
  { value: "Australia/Sydney", label: "Australia, Sydney" },
];

export const DEFAULT_TIMEZONE = "America/Los_Angeles";

/**
 * Best-effort browser timezone detection. Used as the suggested default in
 * the onboarding picker so a user in Denver doesn't have to scroll past
 * Pacific to get to Mountain.
 */
export function detectBrowserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE;
  } catch {
    return DEFAULT_TIMEZONE;
  }
}
